<template>
  <span class="text-left">
    <ed-button button-class="btn btn-actionbar"
               @click="showModal(showAddTransaction)">
      ADD TRANSACTION
    </ed-button>
    <ed-modal title="Add Transaction"
      :show="showAddTransaction"
      @close="showModal(showAddTransaction), closeObj = {}"
      primary-button="ADD"
      :primary-button-disabled="!selectedTransaction"
      @confirm="$emit('transaction', fullTransactionObject)">
      <div slot="body" class='add-transaction-overlay'>
        <p class="small">Select a transaction to include in this {{ envelopeTerm }}.</p>
        <label>Transaction</label>
        <ed-select :options="transactions"
                    v-model="selectedTransaction"
                    label="label"
                    track-by="value"
                    @input="handleTransactionChange"
                  />
      </div>
    </ed-modal>
  </span>
</template>

<script>
  export default {
    data() {
      return {
        closeObj: {},
        selectedTransaction: '',
        transactions: [],
        showAddTransaction: false,
        fullTransactionObject: {}
      }
    },

    props: {
      selectedRows: Array,
      selectedProgram: Object,
      envelopeId: String,
      // PRODUCTDEV-8800: lower case, e.g. "expense report".
      envelopeTerm: { type: String, default: 'envelope' }
    },

    created() {
    },

    methods: {
      async getTransactions() {
        try {
          const response = await this.api.forms.post(this.api.$.evedpaycard.transactions, {
            sort: 'TransactionDate',
            dir: 'DESC',
            start: 0,
            limit: 100,
            isLiveGrid: true,
            filter: JSON.stringify({
              'CardId': this.selectedRows[0].data.CardId,
              'ProgramId': (this.selectedProgram && Object.keys(this.selectedProgram).length !== 0) ? this.selectedProgram.Id : '',
              'Screen': 'AddTransaction',
              'TransactionEnvelopeId': this.envelopeId,
              searchTerm: ''
            })
          })

          if (response && response.data && response.data.Data) {
            const existingTransactionIds = this.selectedRows.map(row => row.data.Id)

            this.transactions = response.data.Data
              .filter(transaction =>
                !existingTransactionIds.includes(transaction.Id)
              )
              .map(transaction => ({
                value: transaction.Id,
                label: `${transaction.Merchant} - ${this.formatDate(transaction.TransactionDate)} - ${transaction.FormattedAmount}`,
                transactionData: {
                  data: transaction
                }
              }))
            this.resetModal()
          }
        } catch (error) {
          console.error('Error while retrieving transactions:', error)
        }
      },

      showModal(showAddTransaction) {
        this.showAddTransaction = !showAddTransaction
        this.resetModal()
        if (this.showAddTransaction) {
          this.getTransactions()
        }
      },

      formatDate(dateString) {
        const dateInMilliseconds = parseInt(dateString.match(/\d+/)[0])
        const formattedDate = new Date(dateInMilliseconds)

        const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0')
        const day = formattedDate.getDate().toString().padStart(2, '0')
        const year = formattedDate.getFullYear()

        return `${month}/${day}/${year}`
      },

      handleTransactionChange() {
        this.fullTransactionObject = this.selectedTransaction && this.selectedTransaction.transactionData
      },

      resetModal() {
        this.fullTransactionObject = {}
        this.selectedTransaction = ''
      }
    }
  }
</script>

<style lang='scss' scoped>
  .add-transaction-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }

  .available-amount-wrapper {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/AddTransactionInEnvelope.vue